/**
 * Blocked User Remapper
 * Flutter: lib/data/models/blocked_user.dart
 */
import type { BlockedUserDto } from '@/data/dtos/blockedUser/blockedUserDto';
import type { JsonObject } from '@/data/types/json';
import type { BlockedUserStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class BlockedUserRemapper {
  static toStorage(dto: BlockedUserDto): BlockedUserStorage {
    return {
      firebaseId: dto.firebaseId,
    };
  }

  static fromFirebaseId(firebaseId: string): BlockedUserStorage {
    return {
      firebaseId,
    };
  }

  static fromJson(data: JsonObject): BlockedUserDto {
    return {
      firebaseId: (data['firebaseId'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): BlockedUserDto[] {
    return dataList.map(BlockedUserRemapper.fromJson);
  }
}
